import { i as f, x as m, s as x } from "../../lit-element-6iugfgmM.js";
import { e as g } from "../../custom-element-wk-AooBb.js";
import { n as v } from "../../property-BWlAHqg_.js";
import "../../query-assigned-elements-B8U94KLQ.js";
import "../../sp-action-button-CjSKZ-qO.js";
import "../../sp-dialog-C9swJ4nV.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-info-outline.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-link-out-light.js";
import "../../overlay-trigger-25h1jNVy.js";
import "../../sp-popover-DFTTgsX0.js";
import { Localize as b, getLocalizedURL as k, getLocale as h } from "../../lib/I18N.js";
import w from "../../events/UservoiceEvent.js";
const y = { "contextual-help.about": "About these search results", "contextual-help.copy-one": "Adobe Fonts uses all the information we know about the font library—names, descriptions, font metadata, foundry and designer biographies—to find the best results for your search term. If we don’t have an exact font match, we may suggest similar options to consider.", "contextual-help.copy-two": "We welcome your feedback on these results, as we’re continually improving how search works.", "contextual-help.uservoice": "Give feedback on results", "contextual-help.alt-copy-one": "Adobe Fonts uses all the information we know about the font library—names, descriptions, font metadata, foundry and designer biographies—to find the best results for your search term." }, E = f`sp-action-button{background:none}@media screen and (max-width: 768px){.contextual-help-title{display:none}}`, C = f`:host{overflow-y:auto}a{color:var(--spectrum-blue-900)}.contextual-help-link{display:flex}h3{font-size:18px;font-weight:700;padding-bottom:15px}p#sp-dialog-description-1-0{margin-top:-8px}sp-dialog{max-width:272px}sp-icon-link-out-light{padding-left:5px;width:13px}`;
var U = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, i = (u, e, s, o) => {
  for (var a, t = o > 1 ? void 0 : o ? $(e, s) : e, n = u.length - 1; n >= 0; n--) (a = u[n]) && (t = (o ? a(e, s, t) : a(t)) || t);
  return o && t && U(e, s, t), t;
};
const d = "af-contextual-help-click", c = class c extends CustomEvent {
  constructor() {
    super(d, { bubbles: !0, composed: !0 });
  }
};
c.EVENT_NAME = d;
let r = c, p = class extends b(x, y) {
  static get styles() {
    return E;
  }
  handleContextualHelpClick() {
    this.dispatchEvent(new r());
  }
  render() {
    return m`<overlay-trigger id="trigger" type="interactive"><sp-action-button quiet slot="trigger" @click="${this.handleContextualHelpClick}"><sp-icon-info-outline slot="icon"></sp-icon-info-outline><p class="contextual-help-title">${this.t("contextual-help.about")}</p></sp-action-button><sp-popover slot="click-content" class="contextual-help-popover" placement="bottom-start"><af-search-results-info></af-search-results-info></sp-popover></overlay-trigger>`;
  }
};
p = i([g("af-contextual-help")], p);
let l = class extends b(x, y) {
  constructor() {
    super(...arguments), this.helpUrl = k("https://adobefonts.uservoice.com/forums/940222-adobe-fonts-feature-requests-and-feedback?category_id=480275", h());
  }
  static get styles() {
    return C;
  }
  handleUservoiceClick() {
    this.dispatchEvent(new w({ link: this.helpUrl }));
  }
  render() {
    return m`<sp-dialog aria-label="${this.t("contextual-help.about")}" size="s" no-divider dismissable><p>${h() == "en-US" ? this.t("contextual-help.copy-one") : this.t("contextual-help.alt-copy-one")}</p><p>${this.t("contextual-help.copy-two")}</p><a class="contextual-help-link" target="_blank" href="${this.helpUrl}" @click="${this.handleUservoiceClick}">${this.t("contextual-help.uservoice")}<sp-icon-link-out-light slot="icon"></sp-icon-link-out-light></a></sp-dialog>`;
  }
};
i([v()], l.prototype, "helpUrl", 2), l = i([g("af-search-results-info")], l);
const T = p;
export {
  r as ContextualHelpEvent,
  d as EVENT_NAME,
  T as default
};
//# sourceMappingURL=ContextualHelp.js.map
